import { AbstractControl, FormGroup } from '@angular/forms';
import { IDataService } from 'app/shared/services/data.service';
import { of } from 'rxjs';
import { map } from 'rxjs/operators';

export class ValidateUnique {
  static createValidator(service: IDataService, id: number | string, propertyName: string) {
    return (control: AbstractControl) => {
      return service.isUnique(control.value, id, propertyName).pipe(map((res) => {
        return res ? null : { notUnique: true };
      }));
    };
  }
}

export class ValidateReservedBySystem {
  static createValidator(service: IDataService, id: number | string, propertyName: string) {
    return (control: AbstractControl) => {
      return service.isUnique(control.value, id, propertyName).pipe(map((res) => {
        return res ? null : { reserveredBySystem: true };
      }));
    };
  }
}

export class ValidateUniqueWithPattern {
  static createValidator(service: IDataService, id: number | string, propertyName: string, regexString: RegExp|string) {
    return (control: AbstractControl) => {      
      const regex = new RegExp(regexString);
      const isMatch = regex.test(control.value);
      if (isMatch==false)
      {
        return of({ pattern: true });
      }
      return service.isUnique(control.value, id, propertyName).pipe(map((res) => {
        return res ? null : { notUnique: true };
      }));
    };
  }
}